import { useState, useEffect } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import ouch from '../../sounds/ouch.mp3'
import ouch2 from '../../sounds/ouch2.mp3'
import auts from '../../sounds/Auts_Jarmo.m4a'
import squish from '../../sounds/squish.wav'
import done from '../../sounds/done.wav'
import { data2 } from './data/data_02_pistosyvyys'

import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { validateImage } from './utils/utils';
import Button from 'react-bootstrap/Button';

import {
    ruisku1, ruisku2, ruisku3, ruisku4, ruisku5, ruisku6, ruisku7, ruisku8, ruisku9, ruisku10, ruisku11, ruisku12, ruisku13, ruisku14, ruisku15, ruisku16, ruisku17, ruisku18, ruisku19, ruisku20, ruisku21, ruisku22, ruisku23, ruisku24, ruisku25, ruisku26, ruisku27, ruisku28, ruisku29, ruisku30, ruisku31, ruisku32, ruisku33,
    ruisku34, ruisku35, ruisku36, ruisku37, ruisku38, ruisku39, ruisku40, ruisku41, ruisku42, ruisku43, ruisku44, ruisku45
} from './images'


const Scene_02_pistosyvyys = ({ scoreHandler, visibilityHandler, soundsOn, timeHandler }) => {

    //Statemjat
    const [teksti, setTeksti] = useState('')
    const [vastaus, setVastaus] = useState('')
    const [oikeaVastaus, setOikeaVastaus] = useState('')
    const [yritystenLkm, setYritystenLkm] = useState(0)
    // const [selectedImage, setSelectedImage] = useState(kuva1)
    const [selectedImage, setSelectedImage] = useState(ruisku1)
    const [shotGiven, setShotGiven] = useState(false)
    const [syvyysOk, setSyvyysOk] = useState(false)


    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);
    const [playOuch] = useSound(ouch2);
    // const [playSquish] = useSound(squish);
    const [playDone] = useSound(done);

    // const [audio] = useState(new Audio(ouch2));
    const [audio] = useState(new Audio(auts));
    const [playing, setPlaying] = useState(false);

    useEffect(() => {
        playing && soundsOn ? audio.play() : audio.pause();
    },
        [playing]
    );

    const depthSet = (value) => {
        // console.log(value[1]);

        switch (true) {
            case (value[1] == 1):
                setSelectedImage(ruisku1)
                setPlaying(false)
                break;
            case (value[1] == 2):
                setSelectedImage(ruisku2)
                setPlaying(false)
                break;
            case (value[1] == 3):
                setSelectedImage(ruisku3)
                setPlaying(false)
                break;
            case (value[1] == 4):
                setSelectedImage(ruisku4)
                setPlaying(false)
                break;
            case (value[1] == 5):
                setSelectedImage(ruisku5)
                setPlaying(false)
                break;
            case (value[1] == 6):
                setSelectedImage(ruisku6)
                setPlaying(false)
                break;
            case (value[1] == 7):
                setSelectedImage(ruisku7)
                setPlaying(false)
                break;
            case (value[1] == 8):
                setSelectedImage(ruisku8)
                setPlaying(false)
                break;
            case (value[1] == 9):
                setSelectedImage(ruisku9)
                setPlaying(false)
                break;
            case (value[1] == 10):
                setSelectedImage(ruisku10)
                setPlaying(false)
                break;
            case (value[1] == 11):
                setSelectedImage(ruisku11)
                setPlaying(false)
                break;
            case (value[1] == 12):
                setSelectedImage(ruisku12)
                setPlaying(false)
                break;
            case (value[1] == 13):
                setSelectedImage(ruisku13)
                setPlaying(false)
                break;
            case (value[1] == 14):
                setSelectedImage(ruisku14)
                setPlaying(true)
                break;
            case (value[1] == 15):
                setSelectedImage(ruisku15)
                setPlaying(true)
                break;
            case (value[1] == 16):
                setSelectedImage(ruisku16)
                setPlaying(true)
                break;
            case (value[1] == 17):
                setSelectedImage(ruisku17)
                setPlaying(true)
                break;
            case (value[1] == 18):
                setSelectedImage(ruisku18)
                setPlaying(true)
                break;
            case (value[1] == 19):
                setSelectedImage(ruisku19)
                setPlaying(true)
                break;
            case (value[1] == 20):
                setSelectedImage(ruisku20)
                setPlaying(true)
                break;
            case (value[1] == 21):
                setSelectedImage(ruisku21)
                setPlaying(true)
                break;
            case (value[1] == 22):
                setSelectedImage(ruisku22)
                setPlaying(true)
                break;
            case (value[1] == 23):
                setSelectedImage(ruisku23)
                setPlaying(true)
                break;
            case (value[1] == 24):
                setSelectedImage(ruisku24)
                setPlaying(true)
                break;
            case (value[1] == 25):
                setSelectedImage(ruisku25)
                setPlaying(true)
                break;
            case (value[1] == 26):
                setSelectedImage(ruisku26)
                setPlaying(true)
                break;
            case (value[1] == 27):
                setSelectedImage(ruisku27)
                setPlaying(true)
                break;
            case (value[1] == 28):
                setSelectedImage(ruisku28)
                setPlaying(true)
                break;
            case (value[1] == 29):
                setSelectedImage(ruisku29)
                setPlaying(true)
                break;
            case (value[1] == 30):
                setSelectedImage(ruisku30)
                setPlaying(true)
                break;
            case (value[1] == 31):
                setSelectedImage(ruisku31)
                setPlaying(true)
                break;
            case (value[1] == 32):
                setSelectedImage(ruisku32)
                setPlaying(true)
                break;
            case (value[1] == 33):
                setSelectedImage(ruisku33)
                setPlaying(true)
                break;
            case (value[1] == 34):
                setSelectedImage(ruisku34)
                setPlaying(true)
                break;
            case (value[1] == 35):
                setSelectedImage(ruisku35)
                setPlaying(true)
                break;
            case (value[1] == 36):
                setSelectedImage(ruisku36)
                setPlaying(true)
                break;
            case (value[1] == 37):
                setSelectedImage(ruisku37)
                setPlaying(true)
                break;
            case (value[1] == 38):
                setSelectedImage(ruisku38)
                setPlaying(true)
                break;
            case (value[1] == 39):
                setSelectedImage(ruisku39)
                setPlaying(true)
                break;
            case (value[1] == 40):
                setSelectedImage(ruisku40)
                setPlaying(true)
                break;
            case (value[1] == 41):
                setSelectedImage(ruisku41)
                setPlaying(true)
                break;
            case (value[1] == 42):
                setSelectedImage(ruisku42)
                setPlaying(true)
                break;
            case (value[1] == 43):
                setSelectedImage(ruisku43)
                setPlaying(true)
                break;
            case (value[1] == 44):
                setSelectedImage(ruisku44)
                setPlaying(true)
                break;
            case (value[1] == 45):
                setSelectedImage(ruisku45)
                setPlaying(true)
                break;

        }

    }





    const injektoi = () => {

        if (!shotGiven) {

            setShotGiven(true)

            if (soundsOn) {
                playDone()
            }



            if (validateImage(selectedImage)) {
                setSyvyysOk(true)

            }




        }
        else {
            if (soundsOn) {
                playWrongAnswer()
            }

            console.log('pistit jo');
        }

    }

    const valmis = () => {

        setSelectedImage(ruisku1)
        setPlaying(false)
        if (syvyysOk) {
            scoreHandler('syvyys ok')
        }
        else {
            scoreHandler('syvyys ei ok')
        }

    }





    return (
        <div className='sceneContainer' >
            <div id='image' className='kuvaBox'>
                <img src={selectedImage} alt="kuva" />
                <RangeSlider
                    id='range-slider'
                    defaultValue={[0, 0]}
                    thumbsDisabled={[true, false]}
                    rangeSlideDisabled={true}
                    max={45}
                    onInput={(e) => depthSet(e)}
                />
            </div>
            <div id='teksti'>
                <p>{data2.kysymysteksti}</p>

            </div>

            <div id='actions'>


                <Button
                    disabled={shotGiven || !playing}
                    onClick={() => injektoi()}>Injektoi</Button>
                <Button
                    disabled={!shotGiven || playing}
                    onClick={() => valmis()}>Valmis</Button>
            </div>
        </div>


    )

}

export default Scene_02_pistosyvyys